import { FC } from "react";
import { SpeedDialAction, SpeedDialActionProps } from "@mui/material";
import { useDevTools } from "components/DevToolsWidget/context";

export const ActionItem: FC<SpeedDialActionProps> = (props) => {
    const { isExpanded } = useDevTools();

    return <SpeedDialAction open={isExpanded} {...props} />;
};
